import React from 'react';
import BaseApi from '../../api/BaseApi.js';
import ScreenCaption from '../screen-caption.js';


export default class ProgramScreen extends React.Component {

    constructor(props) {
        super(props);

        this.state = {currentProgram: {id: null, 
                                       name: "", 
                                        description: ""}};

        this.handleChangeName = this.handleChangeName.bind(this);  
        this.handleChangeDescription = this.handleChangeDescription.bind(this); 
        this.save = this.save.bind(this);                         
    }

    async componentDidMount() {

        if (this.props.args.program && this.props.args.program.length > 0) {
            BaseApi.get("/program", {headers: {
                'Content-Type': 'application/json', 'SESSIONID' : sessionStorage.getItem("session")}, params: {id: this.props.args.program}, withCredentials: true})
            .then(res => { 
                this.setState({currentProgram: res.data})
            })    
            .catch()
        }
    }


    save(event) {
        BaseApi.post('/program', this.state.currentProgram, {headers: {
            'Content-Type': 'application/json', 'SESSIONID' : sessionStorage.getItem("session")}, withCredentials: true})
        .then(res => {
            var currentProgram = this.state.currentProgram
            currentProgram.id = res.data.id
            this.setState({currentProgram: currentProgram})
            this.props.args.program = res.data.id
        })
        .catch(error=>console.log(error))
        
        event.preventDefault();
    }

    handleChangeName(event) {
        var currentProgram = this.state.currentProgram
        currentProgram.name = event.target.value
        this.setState({currentProgram: currentProgram})
    }

    handleChangeDescription(event) {
        var currentProgram = this.state.currentProgram
        currentProgram.description = event.target.value
        this.setState({currentProgram: currentProgram})
    }

    openEvents() {
        this.props.navigate("events", 
        {caller: "program", callargs: this.props.args, programid: this.state.currentProgram.id})

    }

    openProducts() {
        this.props.navigate("products", 
        {caller: "program", callargs: this.props.args, programid: this.state.currentProgram.id})

    }

    openProgramContracts() {
        this.props.navigate("contract-programs", 
        {caller: "program", callargs: this.props.args, programid: this.state.currentProgram.id, caption: "Контракты", program: this.state.currentProgram})

    }

    openRefs() {
        this.props.navigate("refs", 
        {caller: "program", callargs: this.props.args, refrecid: this.state.currentProgram.id})    
    }

    render() {
        const programExists = !!this.state.currentProgram.id;
    
        return (
            <div class="container">
                <ScreenCaption goback={this.props.goback} args={this.props.args} caption={"Программа"}/>
                <div className="row mt-4">
                    <div className="col-lg-8">
                        <div className="card shadow-sm">
                            <div className="card-body">
                                <h6 className="card-title mb-3">
                                    {programExists ? "Редактирование программы" : "Новая программа"}
                                </h6>
                                <form>
                                    <div class="form-group">
                                        <label for="name"> Наименование:</label>
                                        <input type="text" class="form-control w-100" id="name" value={this.state.currentProgram.name} onChange={this.handleChangeName} />
                                        <label for="description">Описание:</label>
                                        <input type="text" class="form-control w-100" id="description"  value={this.state.currentProgram.description} onChange={this.handleChangeDescription} />
                                        <div className="mt-4 d-flex justify-content-end">
                                            <div class="row mt-3">
                                                <button class="btn btn-primary w-100" onClick={this.save}>Сохранить</button>   
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 mt-4 mt-lg-0">
                        <div className="card shadow-sm">
                            <div className="card-body">
                                <h6 className="card-title mb-3">Действия</h6>

                                {programExists && (
                                    <div>
                                        <button 
                                            className="btn btn-outline-primary w-100 mb-2" 
                                            onClick={()=>{this.openEvents()}}>
                                                События
                                        </button>      
                                        <button 
                                            className="btn btn-outline-primary w-100 mb-2"
                                            onClick={()=>{this.openProducts()}}>
                                                Продукты
                                        </button>                             
                                        <button 
                                             className="btn btn-outline-primary w-100 mb-2"
                                            onClick={()=>{this.openRefs()}}>
                                                Ссылки
                                        </button>   
                            
                                    </div>
                                )}
                                {!programExists && (
                                    <p className="text-muted mb-0">
                                    Дополнительные действия станут доступны после сохранения записи.
                                    </p>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div> 
        )
    }

}


// WEBPACK FOOTER //
// ./src/ui/workspace-screens/program.js